import { EpicIcons } from "@constellation-academy/epic-ui";
import { Fieldset } from "primereact/fieldset";
import { OverlayPanel } from "primereact/overlaypanel";
import React, { type MouseEvent, useContext, useRef } from "react";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { QUERY_FRAGMENT } from "./offers-filters.graphql";
import { type OffersFiltersProps } from "./offers-filters.types";
import { Button } from "../../../../components/button";
import {
	DefaultSwitchComponent,
	DefaultTextFieldComponent,
} from "../../../../components/DefaultTextInput";
import {
	SelectAcademiesTagField,
	type SelectAcademiesTagFieldState,
} from "../../../../features/tags/select-academies-tag-field";
import { OffersScreenContext } from "../../offers.context";

export const OffersFilters = ({ queryFragmentRef }: OffersFiltersProps) => {
	const { t } = useTranslation("common");
	const query = useFragment(QUERY_FRAGMENT, queryFragmentRef);
	const { filters, setFilters } = useContext(OffersScreenContext);
	const ref = useRef<OverlayPanel>(null);

	const handleTextOnUpdate = (text?: string) => {
		setFilters({ ...filters, text });
	};
	const handleIsVisibleUpdate = (isVisible?: boolean) => {
		setFilters({ ...filters, isVisible });
	};
	const handleTagsOnUpdate = (tags: SelectAcademiesTagFieldState | undefined = []) => {
		setFilters({ ...filters, tagIds: tags?.map((t) => t.id!), tags });
	};

	const handleButtonOnClick = (e: MouseEvent<HTMLButtonElement>) => {
		ref.current?.toggle(e);
	};

	return (
		<div>
			<Button
				icon={EpicIcons.FILTER}
				onClick={handleButtonOnClick}
				tooltip={t("offers.filter")}
			/>
			<OverlayPanel ref={ref}>
				<Fieldset className={"field"} legend={t("offers.filter")}>
					<p>{t("offers.searchBy")}</p>
					<DefaultTextFieldComponent
						fieldValue={filters.text ?? ""}
						placeholder={t("offers.searchPlaceholder")}
						updateField={handleTextOnUpdate}
						fieldName={"text"}
						required={false}
						isValid={true}
						disabled={false}
					/>
					<p>{t("offers.visibility")}</p>
					<DefaultSwitchComponent
						fieldValue={filters.isVisible ?? undefined}
						updateField={handleIsVisibleUpdate}
						fieldName={"isVisible"}
						required={false}
						isValid={true}
						disabled={false}
					/>
					<p>{t("offers.keywords")}</p>
					<SelectAcademiesTagField
						queryFragmentRef={query}
						fieldValue={filters.tags}
						updateField={handleTagsOnUpdate}
						fieldName={"tags"}
						required={false}
						isValid={true}
						disabled={false}
					/>
				</Fieldset>
			</OverlayPanel>
		</div>
	);
};
